import { gql } from "@apollo/client";

export const GET_AGING_REPORT = gql`
  query Tickets($query: QueryInput, $ticket: TicketInput) {
    tickets(query: $query, ticket: $ticket) {
      tickets {
        _id
        number
        properties {
          bin_location
          date_received
        }
        status
        customer_business_then_name
        created_at
        updated_at
        assets {
          asset_type
        }
      }
      metaData {
        totalCount
        totalPages
        limit
      }
    }
  }
`;
